<template>
  <v-menu
    offset-y
    content-class="custom-language-menu"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        color="primary"
        fab
        class="language-btn"
        style="background-color: transparent !important;"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="icon-circle">
          {{ currentFlag }}
        </v-icon>
      </v-btn>
    </template>

    <v-list flat transparent class="pa-0">
      <v-list-item
        v-for="l in languages"
        :key="l.value"
        :class="{ 'is-active': currentLanguage === l.value }"
        class="language-item pa-0 mb-2"
        @click="changeLanguage(l.value)"
      >
        <v-list-item-content class="pa-0">
          <v-list-item-title class="language-label text-no-wrap">
            {{ l.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { Languages } from '@/locale'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TopBarLocaleChanger',

  data: () => ({
    languages: Languages
  }),

  computed: {
    ...mapGetters('app', ['locale', 'isInitialized']),

    currentLanguage: {
      get() {
        return this.locale
      },

      set(val) {
        if (this.isInitialized) {
          this.$i18n.locale = val
          this.setLocale(val)
        }
      }
    },

    currentFlag() {
      return `$sl-flag-${this.currentLanguage}`
    }
  },

  methods: {
    ...mapActions('app', ['setLocale']),

    changeLanguage(val) {
      this.currentLanguage = val
    }
  }
}
</script>

<style lang="scss">
.v-menu__content.custom-language-menu {
  width: fit-content !important;
  min-width: 150px !important;
  padding: 16px !important;
  border-radius: 16px !important;
  background-color: #fff !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;

  .v-list {
    padding: 0 !important;
    background: transparent !important;
  }

  .language-item.v-list-item {
    width: 100% !important;
    min-height: auto !important;
    padding: 0 !important;
    cursor: pointer;
    border-radius: 50px !important;

    &::before {
      display: none !important;
    }

    &:hover {
      background-color: #F1F4F4 !important;
    }

    &.is-active {
      background-color: $color-primary-container !important;

      .language-label {
        font-weight: $font-weight-semibold !important;
        color: $color-primary-light !important;
      }
    }
  }

  .language-item .v-list-item__content {
    padding: 0 !important;
  }

  .language-item .language-label.v-list-item__title {
    margin: 0 !important;
    padding: 0 !important;
    color: #3F484A !important;

    font-family: 'Open Sans', sans-serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.25px !important;
    text-align: center !important;
  }
}
</style>